<template>
  <div class="action-bar">
    <button v-if="!isEditing" class="btn btn-danger nav-top" @click="$emit('deleteAction')">Удалить</button>
    <button v-if="!isEditing" class="btn btn-primary nav-top" @click="$emit('changeAction')">Изменить</button>
    <button v-if="isEditing" class="btn btn-primary nav-top" @click="$emit('saveAction')">Сохранить</button>
    <button v-if="isEditing" class="btn btn-primary nav-top" @click="$emit('cancelAction')">Отменить</button>
  </div>
</template>

<script>
export default {
  name: 'ActionBar',
  props: ['isEditing']
}
</script>

<style scoped>
  .action-bar button {
    float: right;
    margin-left: 0.3rem;
  }
</style>
